import React, { useState } from "react";
import ChamberSummary from "./ChamberSummary";
import MembersAnalytics from "./MembersAnalytics";
import EventsAnalytics from "./EventsAnalytics";
import EmailsAnalytics from "./EmailsAnalytics";
import InvoicingAnalytics from "./InvoicingAnalytics";
import WebsiteAnalytics from "./WebsiteAnalytics";

type TabType =
  | "chamberSummary"
  | "members"
  | "events"
  | "emails"
  | "invoicing"
  | "website";

const Analytics = () => {
  const [activeTab, setActiveTab] = useState<TabType>("chamberSummary");

  const handleTabChange = ({ tab }: { tab: TabType }) => {
    setActiveTab(tab);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "chamberSummary":
        return <ChamberSummary />;
      case "members":
        return <MembersAnalytics />;
      case "events":
        return <EventsAnalytics />;
      case "emails":
        return <EmailsAnalytics />;
      case "invoicing":
        return <InvoicingAnalytics />;
      case "website":
        return <WebsiteAnalytics />;
      default:
        return <ChamberSummary />;
    }
  };

  const tabItems = [
    { id: "chamberSummary", label: "Overview" },
    { id: "members", label: "Members" },
    { id: "events", label: "Events" },
    { id: "emails", label: "Emails" },
    { id: "website", label: "Website" },
    { id: "invoicing", label: "Invoicing" },
  ];

  return (
    <div className="">
      {/* Tab Navigation */}
      <div className="border-b border-gray-200 mb-6 overflow-x-auto">
        <nav
          className="pl-8 md:pl-0 flex space-x-8"
          aria-label="Analytics Tabs"
        >
          {tabItems.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => handleTabChange({ tab: id as TabType })}
              className={`
                whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === id
                    ? "border-cpaGold text-cpaGold"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
              aria-current={activeTab === id ? "page" : undefined}
              aria-label={`${label} tab`}
              tabIndex={0}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="analytics-content">{renderTabContent()}</div>
    </div>
  );
};

export default Analytics;
